export const PAYOUT_PERCENTAGE = 0.5;
